import Vue from 'vue';
import { MultiGuard, AssertionResolver,  CSSResolver } from '../util/NavMiddleware'
import Router from 'vue-router';
Vue.use(Router)

const _404 = () => import(/* webpackChunkName: "404" */  "../view/404.vue")
const Bupa = () => import(/* webpackChunkName: "bupa" */  "../view/chat/Bupa.vue")
const router = new Router({
  mode: "history",
  routes: [
    { path: "/",  redirect: "/404" },
    { path: "/bupa/:key", name: 'bupa', component: Bupa, meta:{ auth:false } },
    { path: "/takaful/:key", name: 'takaful', component: Bupa, meta:{ auth:false } },
    { path: "/bayzat/:key", name: 'bupa', component: Bupa, meta:{ auth:false } },
    { path: "/404", name: '404', component: _404, meta:{ auth:false } },
  ]
});

// All the Route Authentication and Data Binding hanppening here
router.beforeEach(
  MultiGuard([
    AssertionResolver,
    CSSResolver,    
  ])
)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js